// Standalone dispatch desktopových akcí do skrytého Magic control iframu (přes `getMagicDesktopFrame()`).
// Použití mimo React kontext bridge — volá se z user menu / patičky Nástroje.

import { getMagicDesktopFrame } from '@/shared/lib/legacyMagic';
import { PHOENIX_TO_MAGIC_ACTIONS } from './types';

/**
 * Otevři libovolný legacy form dle GlobalName (např. `Menu.UserPreference`, `External.Logs`). Magic
 * `AnyFormMessageHandler` otevře form a `ShowModal()` probublá zpět jako `form/open` → bridge otevře okno.
 */
export function sendMagicOpenForm(formGlobalName: string, params?: Record<string, string>): void {
  const frame = getMagicDesktopFrame();
  if (!frame) return;
  frame.postMessage(
    {
      action: PHOENIX_TO_MAGIC_ACTIONS.desktopOpenForm,
      data: { Form: formGlobalName, ...(params ?? {}) },
      requestId: crypto.randomUUID(),
    },
    '*'
  );
}
